"use client";

import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "VESTA provided the structural clarity I needed to secure my family's legacy for generations.",
  author: "Arthur Sterling",
  position: "Private Investor",
  restaurant: "Sterling Holdings — Maryland",
  portrait: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_arthur_sterling.png",
  portraitSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_arthur_sterling.png-wvc-srcset",
  portraitSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_arthur_sterling.png-wvc-sizes"
}, {
  quote: "Their counsel on sovereign citizenship is unmatched. They navigate complex jurisdictions with absolute precision.",
  author: "Elena Vance",
  position: "International Consultant",
  restaurant: "Vance Global — Annapolis",
  portrait: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_elena_vance.png",
  portraitSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_elena_vance.png-wvc-srcset",
  portraitSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_elena_vance.png-wvc-sizes"
}, {
  quote: "Legal architecture that feels like a fortress. VESTA is the gold standard for asset protection.",
  author: "Julian Thorne",
  position: "Estate Executor",
  restaurant: "Thorne Estates — Baltimore",
  portrait: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_julian_thorne.png",
  portraitSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_julian_thorne.png-wvc-srcset",
  portraitSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/client_julian_thorne.png-wvc-sizes"
}];
const partners = [{
  name: "Maryland Bar",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_maryland_bar.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_maryland_bar.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_maryland_bar.png-wvc-sizes"
}, {
  name: "Trust Law Institute",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_trust_law.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_trust_law.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_trust_law.png-wvc-sizes"
}, {
  name: "Sovereign Rights Council",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_sovereign_council.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_sovereign_council.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/partner_sovereign_council.png-wvc-sizes"
}];
export default function ClientPerspectives() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setActiveIndex(prev => (prev + 1) % testimonials.length);
        setIsFading(false);
      }, 1200);
    }, 7000);
    return () => clearInterval(interval);
  }, []);
  const goTo = (i: number) => {
    if (i === activeIndex) return;
    setIsFading(true);
    setTimeout(() => {
      setActiveIndex((i + testimonials.length) % testimonials.length);
      setIsFading(false);
    }, 1200);
  };
  const current = testimonials[activeIndex];
  return <section data-section-id="4080" id="client-perspectives" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 px-6">
      {}
      <div className="pointer-events-none absolute -top-32 -right-32 w-[600px] h-[600px] rounded-lg opacity-40" style={{
      background: "radial-gradient(circle at center, hsl(45 100% 48% / 0.15) 0%, hsl(45 100% 48% / 0.05) 35%, transparent 70%)"
    }} />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div ref={ref} className={`relative mx-auto max-w-4xl transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <p className="font-mono text-center text-xs tracking-[0.35em] uppercase mb-20" style={{
        color: "var(--muted-foreground)"
      }}>
          06 — Client Perspectives
        </p>

        {}
        <div className="relative min-h-[420px] md:min-h-[380px]">
          {}
          <Quote aria-hidden className="absolute -top-4 -left-2 md:-left-6 w-32 h-32 md:w-40 md:h-40 opacity-15" style={{
          color: "var(--primary)"
        }} strokeWidth={1} />

          <div className={`relative transition-opacity duration-[1200ms] ease-in-out ${isFading ? "opacity-0" : "opacity-100"}`}>
            <blockquote className="font-serif italic text-center text-2xl md:text-[2.5rem] leading-[1.3] tracking-tight px-4 md:px-12 pt-8" style={{
            color: "var(--foreground)"
          }}>
              {current.quote}
            </blockquote>

            {}
            <div className="mt-14 flex flex-col items-center">
              <div className="w-[60px] h-[60px] rounded-lg overflow-hidden ring-1 ring-border">
                <img src={current.portrait} data-wvc-srcset={current.portraitSrcset} data-wvc-sizes={current.portraitSizes} alt={current.author} className="w-full h-full object-cover grayscale" loading="lazy" decoding="async" />
              </div>

              <p className="font-serif italic text-lg md:text-xl mt-5" style={{
              color: "var(--foreground)"
            }}>
                {current.author}
              </p>

              <Separator className="my-4 w-12" style={{
              backgroundColor: "var(--border)"
            }} />

              <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-center" style={{
              color: "var(--muted-foreground)"
            }}>
                {current.position} · {current.restaurant}
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 flex items-center justify-center gap-6">
          <Button variant="ghost" size="icon" onClick={() => goTo(activeIndex - 1)} aria-label="Previous testimonial" className="h-7 w-7 hover:bg-transparent" style={{
          color: "var(--muted-foreground)"
        }}>
            <ChevronLeft className="w-4 h-4" />
          </Button>

          <div className="flex items-center gap-3">
            {testimonials.map((_, i) => <Button key={i} data-index={i} variant="ghost" onClick={() => goTo(i)} aria-label={`Go to testimonial ${i + 1}`} className="h-px p-0 hover:bg-transparent" style={{
            width: i === activeIndex ? "32px" : "20px",
            backgroundColor: i === activeIndex ? "var(--primary)" : "var(--muted-foreground)",
            opacity: i === activeIndex ? 1 : 0.4
          }} />)}
          </div>

          <Button variant="ghost" size="icon" onClick={() => goTo(activeIndex + 1)} aria-label="Next testimonial" className="h-7 w-7 hover:bg-transparent" style={{
          color: "var(--muted-foreground)"
        }}>
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>

        {}
        <div className="mt-24 pt-12 border-t" style={{
        borderColor: "var(--border)"
      }}>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-center mb-8" style={{
          color: "var(--muted-foreground)"
        }}>
            Affiliations & Recognition
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6 opacity-50">
            {partners.map((partner, i) => <img key={i} data-index={i} src={partner.logo} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.name} className="h-6 md:h-7 w-auto object-contain grayscale" loading="lazy" />)}
          </div>
        </div>
      </div>
    </section>;
}